import angular from 'angular';
import uiRouter from 'angular-ui-router';
import userCardRowComponent from './userCardRow.component';

let userCardRowModule = angular.module('userCardRow', [
  uiRouter,
])

.component('userCardRow', userCardRowComponent)

.name;

export default userCardRowModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/userCardRow.js